import { Form, Input, Button } from "antd";
import { PhoneInput } from "./PhoneInput";


import styles from "./ContactForm.module.css";

const checkPhone =
  (invalidPhoneMessage) =>
  (_, { number }) => {
    if (!number) {
      return Promise.reject(new Error(invalidPhoneMessage));
    }

    return Promise.resolve();
  };

export const ContactForm = ({ buttonText = "Отправить", form, setSubmitted, onSubmit }) => {
  
  let phoneInvalidMessage = "Телефон является обязательным полем";

  return (
    <div>
      <h5 className={styles.heading}>Задать вопрос</h5>
      <p className={styles.description}>Мы с радостью на него ответим</p>
      <Form
        form={form}
        layout="vertical"
        name="form_in_modal"
        
        onFinish={(values) => {
          setSubmitted(true);
          onSubmit(values)
        }}
      >
        <Form.Item
          name={["user", "question"]}
          rules={[{ required: true, message: "Укажите Ваш вопрос" }]}
        >
          <Input.TextArea className={styles.textarea} rows={4} placeholder="Ваш вопрос" />
        </Form.Item>
        <Form.Item
          name={["user", "name"]}
          rules={[
            { required: true, message: "Имя является обязательным полем" },
          ]}
        >
          <Input className={`${styles.input} ${styles.inputPadding}`} placeholder="Имя" />
        </Form.Item>
        <Form.Item
          messageVariables={{ label: "Телефон" }}
          name={["user", "phone"]}
          rules={[
            {
              validator: checkPhone(phoneInvalidMessage),
              message: phoneInvalidMessage,
            },
          ]}
        >
          <PhoneInput
            className={`${styles.input} ${styles.phoneInput}`}
            language="ru"
          />
        </Form.Item>
        <Form.Item>
          <Button
            className={styles.button}
            size="large"
            type="primary"
            htmlType="submit"
          >
            {buttonText}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
